import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { theme } from '../../domain/theme';
import { numberOrArrayPlusNull } from '../propTypes';

const getIconStyles = (size, color) => {
  let iconStyles;

  const colorStyles =
    color &&
    css`
      color: ${color};
    `;

  if (typeof size === 'object') {
    const tabletStyles =
      size[1] &&
      css`
        ${theme.mq.tablet} {
          height: ${size[1]}px;
          width: ${size[1]}px;
        }
      `;

    const smallDesktopStyles =
      size[2] &&
      css`
        ${theme.mq.small_desktop} {
          height: ${size[2]}px;
          width: ${size[2]}px;
        }
      `;

    const largeDesktopStyles =
      size[3] &&
      css`
        ${theme.mq.large_desktop} {
          height: ${size[3]}px;
          width: ${size[3]}px;
        }
      `;

    iconStyles = css`
      height: ${size[0]}px;
      width: ${size[0]}px;
      ${tabletStyles};
      ${smallDesktopStyles};
      ${largeDesktopStyles};
      ${colorStyles};
      fill: currentColor;
    `;
  } else {
    iconStyles = css`
      height: ${size}px;
      width: ${size}px;
      ${colorStyles};
      fill: currentColor;
    `;
  }

  return iconStyles;
};

export const WithIcon = (name, viewBox, component) => {
  /** *
   * removing namespace attribute as it is passed
   * to the DOM node through setAttributeNS method by default:
   * https://github.com/facebook/react/blob/master/src/renderers/dom/shared/SVGDOMPropertyConfig.js
   * https://github.com/facebook/react/issues/2250
   *
   * additionally, choosing to use conventional title
   * tag rather than xlinkTitle attribute based on:
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/xlink:title
   ** */

  const IconInner = ({ size = 24, color, alt, display = 'inline-block' }) => {
    return (
      <svg
        css={css`
          ${getIconStyles(size, color)};
          display: ${display};
        `}
        viewBox={viewBox}
        aria-label={alt || name}
        width={size[0] || size}
        height={size[0] || size}
      >
        {component}
      </svg>
    );
  };

  IconInner.propTypes = {
    size: numberOrArrayPlusNull,
    color: PropTypes.string,
    alt: PropTypes.string,
    display: PropTypes.string
  };

  return IconInner;
};

WithIcon.propTypes = {
  name: PropTypes.string.isRequired,
  viewBox: PropTypes.string.isRequired,
  component: PropTypes.element.isRequired
};
